import { IAssignment, ISubmission } from '@/components/interfaces';
import { GradingStatus, IStudent } from 'components/staffer/AssignmentsBasedGradesTable/types';
import { useEffect, useRef, useState } from 'react';

interface ApplyGradesFilterProps {
  gradingStatusFilter: GradingStatus[];
  students: IStudent[];
  submissions: ISubmission[];
}

export const applyGradesFilters = ({
  gradingStatusFilter,
  students,
  submissions,
}: ApplyGradesFilterProps) => {
  if (gradingStatusFilter.length === 0) return students;

  const studentIdMap = submissions.reduce((acc, submission) => {
    if (gradingStatusFilter.includes(submission.graded_status) && submission.user_type === 'Student') {
      acc[submission.user_id] = true;
    }
    return acc;
  }, {});

  return students.filter(student => studentIdMap[student.id]);
};

// Matches an assignment if ANY of its type_keys is selected (inclusive match — PLAT-17677).
export const filterAssignmentsByType = (assignments: IAssignment[], assignmentTypeFilter: string[]) => {
  if (assignmentTypeFilter.length === 0) return assignments;

  return assignments.filter(assignment => (
    assignment.assignment_details.type_keys?.some(key => assignmentTypeFilter.includes(key))
  ));
};

export const getSubmissionScore = (
  submission: ISubmission,
  noScoreValue: number | string = 0,
) => (
  submission?.total_score_override
    ?? submission?.normalized_total_score
    ?? submission?.total_score
    ?? noScoreValue
);

export const toDisplayScore = (
  score: number | string,
  maxPoints: number,
  showPercentages: boolean,
) => {
  if (!showPercentages || typeof score !== 'number' || Number.isNaN(score) || maxPoints <= 0) return score;

  return `${Math.round((score / maxPoints) * 100)}%`;
};

export const useLeftOffset = () => {
  const resizeObserverRef = useRef<ResizeObserver>();
  const [leftOffset, setLeftOffset] = useState<number>(0);

  useEffect(() => {
    setTimeout(() => {
      const node = document.querySelector('#left-nav-bar') as HTMLDivElement;

      resizeObserverRef.current = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target !== node) return;

          const newWidth = entry.contentRect.width;
          setLeftOffset(newWidth);
        });
      });

      resizeObserverRef.current.observe(node);
    }, 100);

    return () => resizeObserverRef.current?.disconnect();
  }, []);

  return { leftOffset };
};
